(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"]) return;
  try {
    
  (function () {
    if (customElements.get('countdown-announcement')) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    // Diferencia (ms) entre la hora de la zona indicada y UTC en un instante dado
    function tzOffset(ts, tz) {
      var dtf = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hourCycle: 'h23',
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric'
      });
      var p = {};
      dtf.formatToParts(new Date(ts)).forEach(function (x) { p[x.type] = x.value; });
      var asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
      return asUtc - Math.floor(ts / 1000) * 1000;
    }

    // Convierte una fecha/hora "de reloj" en la zona indicada a un timestamp real
    function zonedToUtc(y, mo, d, h, mi, tz) {
      var guess = Date.UTC(y, mo - 1, d, h, mi, 0);
      try {
        var off = tzOffset(guess, tz);
        var t = guess - off;
        var off2 = tzOffset(t, tz);
        if (off2 !== off) t = guess - off2;
        return t;
      } catch (e) {
        return new Date(y, mo - 1, d, h, mi, 0).getTime();
      }
    }

    class CountdownAnnouncement extends HTMLElement {
      connectedCallback() {
        this.inEditor = !!(window.Shopify && window.Shopify.designMode);
        this.key = this.dataset.dismissKey;

        if (!this.inEditor && this.isDismissed()) {
          this.hidden = true;
          return;
        }

        var closeBtn = this.querySelector('[data-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', this.dismiss.bind(this));
        }

        this.timerEl = this.querySelector('[data-timer]');
        this.els = {
          d: this.querySelector('[data-days]'),
          h: this.querySelector('[data-hours]'),
          m: this.querySelector('[data-minutes]'),
          s: this.querySelector('[data-seconds]')
        };

        var tz = this.dataset.timezone || 'Europe/Madrid';

        if (this.dataset.mode === 'loop') {
          // Contador en bucle: todos los clientes ven la misma cuenta atrás,
          // que vuelve a empezar cada vez que llega a cero.
          this.loopMs = parseInt(this.dataset.loopMs, 10) || 14400000;
          this.anchor = zonedToUtc(2026, 1, 1, 0, 0, tz);
        } else {
          this.end = this.parseEnd(tz);
          if (this.end === null) {
            if (this.timerEl && !this.inEditor) this.timerEl.hidden = true;
            return;
          }
        }

        this.tick();
        this.interval = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      parseEnd(tz) {
        var date = (this.dataset.endDate || '').trim();
        var time = (this.dataset.endTime || '23:59').trim();
        var y, mo, d, m;

        if ((m = date.match(/^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})$/))) {
          d = +m[1]; mo = +m[2]; y = +m[3];          // 31/10/2026
        } else if ((m = date.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/))) {
          y = +m[1]; mo = +m[2]; d = +m[3];          // 2026-10-31
        } else {
          return null;
        }

        var t = time.match(/^(\d{1,2})[:.h](\d{2})$/);
        var h = t ? +t[1] : 23;
        var mi = t ? +t[2] : 59;

        return zonedToUtc(y, mo, d, h, mi, tz);
      }

      tick() {
        var now = Date.now();

        if (this.loopMs) {
          var elapsed = ((now - this.anchor) % this.loopMs + this.loopMs) % this.loopMs;
          this.render(this.loopMs - elapsed);
          return;
        }

        var diff = this.end - now;

        if (diff <= 0) {
          clearInterval(this.interval);
          this.render(0);
          if (this.inEditor) return;   // en el editor se sigue viendo, con 00
          if (this.dataset.onEnd === 'hide_timer') {
            if (this.timerEl) this.timerEl.hidden = true;
          } else {
            this.hidden = true;
          }
          return;
        }

        this.render(diff);
      }

      render(ms) {
        var total = Math.floor(ms / 1000);
        var days = Math.floor(total / 86400);
        var hours = Math.floor((total % 86400) / 3600);
        var mins = Math.floor((total % 3600) / 60);
        var secs = total % 60;
        if (!this.els.d) hours += days * 24;   // sin casilla de días, las horas lo acumulan
        if (this.els.d) this.els.d.textContent = pad(days);
        if (this.els.h) this.els.h.textContent = pad(hours);
        if (this.els.m) this.els.m.textContent = pad(mins);
        if (this.els.s) this.els.s.textContent = pad(secs);
      }

      isDismissed() {
        try { return sessionStorage.getItem(this.key) === '1'; } catch (e) { return false; }
      }

      dismiss() {
        try { sessionStorage.setItem(this.key, '1'); } catch (e) {}
        clearInterval(this.interval);
        this.hidden = true;
      }
    }

    customElements.define('countdown-announcement', CountdownAnnouncement);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
